/** Response received after importing a QC lot. */
export class QcLotImportResponse {
  status!: string;
  calLot!: QcLot;
}
/** Represents a Quality Control (QC) lot with metadata, associated assays, and vial data. */
export class QcLot {
  kitName: string = '';
  methodId!: number;
  assayPanelName: string = '';
  controlCatalogNumber: string = '';
  aPFName: string = '';
  masterLotNumber: string = '';
  controlLotExpirationDate: string = '';
  valueAssignmentVersion!: number;
  reagentLot: string = '';
  recommendedStorageTemp: string = '';
  fillVolume!: number;
  vialCount!: number;
  assays: QcAssay[] = [];
  vials: QcVial[] = [];
}
/** Represents an assay associated with a QC lot, including its configuration. */
export class QcAssay {
  region!: number;
  assayName: string = '';
  units: string = '';
  decimalPrecision!: number;
  sdForPosCtrl!: number;
  sdForNegCtrl!: number;
}
/** Represents a single vial within a QC lot, including its levels and identification metadata. */
export class QcVial {
  barcode: string = '';
  levelLotNumber: string = '';
  level!: string;
  levels: QcVialLevel[] = [];
  vialNumber!: number;
  sdCalculationParameterType: string = '';
}
/** Represents data for a specific level within a QC vial for a given assay region. */
export class QcVialLevel {
  region!: number;
  mean!: number;
  sd!: number;
  lowerLimit!: number;
  upperLimit!: number;
  dilution!: number;
  sdCalculationParameter!: number;
}
/**  Metadata describing a QC lot file, typically used during file import or export. */
export class QcLotFile {
  panelName: string = '';
  calLotNumber: string = '';
  revision: string = '';
  sourceFile: string = '';
}
